<div
    class="agpr-entityFullProfile"
    [agprLoading]="!_entity"
>
    <div class="agpr-entityFullProfile-main">
        <agpr-scroll-panel
            #scrollPanel
            (scrolledTopChange)="scrollTopChanged($event)"
            *ngIf="_entity"
        >
            <div class="agpr-entityFullProfile-main-scrollContent">
                <div class="agpr-entityFullProfile-toolbar">
                    <div class="agpr-entityFullProfile-toolbar-container">
                        <div class="agpr-entityFullProfile-toolbar-content">
                            <button #navBackButton *ngIf="backButtonLocalization" class="agpr-profileToggle"
                                (click)="navigateBack()" [attr.aria-label]="backButtonLocalization | localize"
                                [agprTooltip]='backButtonLocalization'>
                                <span class="fa-solid fa-duotone fa-circle-chevron-right" aria-hidden="true"></span>
                            </button>
                        </div>
                        <div *ngIf="!scrollTop" class="agpr-entityFullProfile-toolbar-title">
                            {{ title | localize}}
                        </div>
                    </div>
                </div>
                <agpr-entity-profile-details
                    [id]="id + '_entityProfileDetail'"
                    [entity]="_entity"
                    [privateData]="entityType === entityTypes.CONTACT ? _contactPrivateData : _outletPrivateData"
                    [outletPrivateAddresses]="_outletPrivateData?.addresses ? _outletPrivateData?.addresses : []"
                    [currentUser]="currentUser"
                    [selectedEmployment]="selectedEmployment"
                    [outletPrivateData]="_outletPrivateData"
                    [contactPrivateData]="_contactPrivateData"
                    [dialogMode]="dialogMode"
                ></agpr-entity-profile-details>
            </div>
        </agpr-scroll-panel>
    </div>
</div>
